module.exports = __webpack_public_path__ + "assets/img/ticket_way_img.4b66fff1.png";